'use strict';

function inherits(ctor, superCtor) {
  ctor.prototype = Object.create(superCtor.prototype, {
    constructor: {
      value: ctor,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
}

module.exports = inherits;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/algoliasearch-helper/src/functions/inherits.js
// module id = 712
// module chunks = 0 1 2 3 4 5 6 7 8